module.exports = __webpack_public_path__ + "img/2025-07-21a_6.296d8877.jpg";